import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "calculation-states-log" }
const _hoisted_2 = {
  class: "calculation-states-log__content",
  ref: "logContent"
}
const _hoisted_3 = {
  key: 0,
  class: "calculation-states-log__list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "calculation-states-log__title" }, "Состояние загрузки:", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isInitLoadedData)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log) => {
              return (_openBlock(), _createElementBlock("li", {
                key: log.id,
                class: "calculation-states-log__item"
              }, _toDisplayString(_ctx.getText(log)), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}